<template>
  <!-- 联系人列表 -->
  <ul>
    <li class="d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover" v-for="item in items" :key="item.userCode" @click="itemClickEvent(item)">
      <div class="d-table-cell v-a-middle h-100-p w-64">
        <span class="d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none" style="background-color: #704BFE;">{{getShortNickname(item.userName)}}</span>
      </div>
      <div class="d-table-cell v-a-middle h-100-p">
        <div :style="{width:listWidth+'px'}">
          <p class="t-ellipsis l-h-1-6-em">{{item.userName}}<span class="f-s-12"> {{item.userCode}}{{getUserRole(item)}}</span></p>
          <p class="t-ellipsis l-h-1-6-em f-s-12 c-g-500">{{item.stationName}} {{item.stationCode}}</p>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: function () {
        return [];
      }
    },
    width: {
      type: Number,
      default: 185
    }
  },
  data: function () {
    return {
      listWidth: 185
    };
  },
  mounted: function () {
    // console.log("contact-list",this.items);
  },
  methods: {
    // 用户信息
    getUserRole: function (item) {
      var str = '';
      str += item.role && item.role !== '无' ? ' ' + item.role : '';
      return str;
    },
    // 截取名称后俩位
    getShortNickname: function (name) {
      name = name || '';
      var len = name.length;
      return name.slice(len - 2, len);
    },
    // 点击联系人
    itemClickEvent: function (item) {
      this.$emit('createSession', item);
    }
  },
  watch: {
    width: function (val) {
      this.listWidth = val - 65;
    }
  }
}
</script>
